import {database} from 'firebaseApp';
import {useState, useEffect, useContext} from 'react';
import {Event} from './types';
import {TimeContext} from 'contexts/TimeContext';

const GLOBAL_EVENT_QUEUE = '%GLOBAL%';

export const EVENT_TYPES = {
  newMatch: 'NEW_MATCH',
  failedMatch: 'FAILED_MATCH',
  peerLearnNudge: 'PEER_LEARN_NUDGE',
  careHoursNudge: 'NUDGE_CARE_HOURS',
  careHoursMatch: 'NEW_CARE_MATCH',
  slNoCareStudents: 'SL_NO_CARE_STUDENTS',
};

export interface EventsByType {
  [k: string]: Array<Event>;
}

export const useEvents = (
  uid: string,
  courseId: string,
): [EventsByType, (event: Event) => void] => {
  const [events, setEvents] = useState([]);

  const addEvent = (newEvent: Event) => {
    setEvents(events => [...events, newEvent]);
  };

  const removeEvent = (newEvent: Event) => {
    setEvents(events =>
      events.filter(event => event.eventId !== newEvent.eventId),
    );
  };

  const {serverTimeDelta, getServerTimeMs} = useContext(TimeContext);
  // The listeners below are never detached, so they must attach once rather
  // than again each time the server delta is re-measured.
  const hasServerTime = serverTimeDelta !== undefined;

  useEffect(() => {
    if (!hasServerTime) return;
    if (!uid) return;
    const eventListenerRef = database.ref(`/${courseId}/events/${uid}`);
    const eventListenerRefGlobal = database.ref(
      `/${courseId}/events/${GLOBAL_EVENT_QUEUE}`,
    );
    const eventListenerRefs: [typeof eventListenerRef, string][] = [
      [eventListenerRef, uid],
      [eventListenerRefGlobal, GLOBAL_EVENT_QUEUE],
    ];
    for (const [ref, dest] of eventListenerRefs) {
      const now = getServerTimeMs();
       
      // eslint-disable-next-line @typescript-eslint/no-unused-vars -- TODO: [#915](https://github.com/CodeinPlace/cip-webapp/issues/915) - fix legacy lint issue
      const dateNow = Date.now();
      ref
        .orderByChild('timestampMS')
        .startAt(now)
         
        // eslint-disable-next-line @typescript-eslint/no-unused-vars -- TODO: [#915](https://github.com/CodeinPlace/cip-webapp/issues/915) - fix legacy lint issue
        .on('child_added', (snap, prevChildKey) => {
          // const eventListenerRef = database.ref(`/${courseId}/queue/`)
          // eventListenerRef.on('child_added', (snap, prevChildKey) => {
          // console.log(">>>>>> Child added ", snap.val())
          const val = snap.val();
          val['eventDest'] = dest;
          if (!val?.ignore) {
            // only add events without an ignore flag
            addEvent(val);
          }
        });
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps -- TODO: [#915](https://github.com/CodeinPlace/cip-webapp/issues/915) - fix legacy lint issue
  }, [hasServerTime]);

  // eslint-disable-next-line prefer-const -- TODO: [#915](https://github.com/CodeinPlace/cip-webapp/issues/915) - fix legacy lint issue
  let eventsByType: EventsByType = Object.fromEntries(
    Object.values(EVENT_TYPES).map(eventType => [eventType, []]),
  );
  events.forEach(event => {
    if (!(event.eventType in eventsByType)) {
      console.error('Unknown event type: ', event.eventType);
      console.error('Valid types: ', Object.values(EVENT_TYPES));
    } else {
      eventsByType[event.eventType].push(event);
    }
  });

  return [eventsByType, removeEvent];
};
